import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import Cookies from "js-cookie";
import moment from "moment";
import qs from "qs";

import Title from "../../../../components/common/Title/Title";
import Breadcrumb from "../../../../components/common/Breadcrumb/Breadcrumb";
import TextInput from "../../../../components/common/TextInput/TextInput";
import MultipleSelect from "../../../../components/common/MultipleSelect/MultipleSelect";
import CustomTable from "../../../../components/common/Table/CustomTable";
import CustomDatePicker from "../../../../components/common/DatePicker/CustomDatePicker";
import FilterButton from "../../../../components/common/Button/FilterButton";
import { AxiosCustomGet } from "../../../../components/axios/AxiosCustom";
import Config from "../../../../components/axios/Config";
import ButtonInput from "../../../../components/common/Button/ButtonInput";
import ChooseOutletDialog from "../../components/ChooseOutletDialog";
import ActiveOutlets from "../../components/ActiveOutlets/ActiveOutlets";
import DetailDialog from "../../components/DetailDialog";
import ExportButton from "../../components/ExportButton";
import PreviewImage from "../../../../components/common/PreviewImage/PreviewImage";
import TotalSummary from "../../report/pawn_transaction/components/TotalSummary";
import SwalToast from "../../../../components/helpers/SwalToast";

import {
  convertPawnTransaction,
  convertTransactionDetail,
  convertTransactionTypeCount,
} from "./helpers";
import {
  convertCategory,
  convertOutletList,
  convertTenor,
} from "../../helpers";
import { CurrencyFormat } from "../../../../components/helpers";

import {
  initFilterInput,
  transactionTypeList,
  renderColumns,
} from "./constants";
import {
  initCategoryAndTenor,
  initPaymentAndTenorType,
  tenorTypeList,
  paymentTypeList,
  paymentMethodList,
} from "../../constants";

import "../../styles.css";

const PawnTransaction = () => {
  const [filterInput, setFilterInput] = useState(initFilterInput);
  const [categoryList, setCategoryList] = useState([]);
  const [outletList, setOutletList] = useState([]);
  const [pawnTransactionList, setPawnTransactionList] = useState([]);
  const [transactionTypeCount, setTransactionTypeCount] =
    useState(transactionTypeList);
  const [isOutletDialogOpen, setIsOutletDialogOpen] = useState(false);
  const [isDetailDialogOpen, setIsDetailDialogOpen] = useState(false);
  const [outletCheckedList, setOutletCheckedList] = useState([]);
  const [indeterminate, setIndeterminate] = useState(false);
  const [outletCheckAll, setOutletCheckAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isChangingType, setIsChangingType] = useState(false);
  const [tablePagination, setTablePagination] = useState({});
  const [selectedTransaction, setSelectedTransaction] = useState({});

  const [selectedCategory, setSelectedCategory] =
    useState(initCategoryAndTenor);
  const [selectedPaymentType, setSelectedPaymentType] = useState(
    initPaymentAndTenorType
  );
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(
    initPaymentAndTenorType
  );
  const [selectedTenorType, setSelectedTenorType] = useState(
    initPaymentAndTenorType
  );
  const [selectedTenor, setSelectedTenor] = useState(initCategoryAndTenor);
  const [dateValue, setDateValue] = useState([]);
  const [pageSizeValue, setPageSizeValue] = useState(10);
  const [searchNameValue, setSearchNameValue] = useState("");
  const [imgLink, setImgLink] = useState("");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [tenorList, setTenorList] = useState([]);
  const [financialData, setFinancialData] = useState({});

  const getTenorList = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}tenors`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setTenorList(convertTenor(response.data.data));
      }
    );
  };

  const getCategory = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}product-categories`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setCategoryList(convertCategory(response.data.data.items));
      }
    );
  };

  const getOutlet = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet/all`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setOutletList(convertOutletList(response.data.data));

        const outletListId = response.data.data.map((outlet) => {
          return outlet.id;
        });

        setOutletCheckedList(outletListId);
        setIndeterminate(false);
        setOutletCheckAll(true);
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data outlet: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getPawnTransactionList = () => {
    setLoading(true);
    const data = {
      query: filterInput.searchName,
      product_category: filterInput.category,
      payment_type: filterInput.paymentType,
      tenor_type: filterInput.tenorType,
      tenor: filterInput.tenor,
      outlet_id_list: filterInput.outlets,
      date_start: filterInput.transactionStartDate,
      date_end: filterInput.transactionEndDate,
      page: parseInt(filterInput.page),
      size: parseInt(filterInput.pageSize),
      transaction_type: filterInput.transactionType,
      sorting_field: filterInput.sortingField,
      sorting_order: filterInput.sortingOrder,
      payment_method: filterInput.paymentMethod,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}transaction-history/gadai`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      ),
      (response) => {
        setLoading(false);
        setPawnTransactionList(
          convertPawnTransaction(
            response.data.data.items.gadai_transaction_list,
            handleOpenPreview
          )
        );

        if (!isChangingType) {
          setTransactionTypeCount(
            convertTransactionTypeCount(
              transactionTypeList,
              response.data.data.items.transaction_type_count,
              filterInput.transactionType
            )
          );
        }

        setTablePagination({
          current: response.data.data.page,
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });

        setIsChangingType(false);
        getTotalSummary();
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data transaksi: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getTotalSummary = () => {
    setLoading(true);
    const data = {
      query: filterInput.searchName,
      product_category: filterInput.category,
      payment_type: filterInput.paymentType,
      tenor_type: filterInput.tenorType,
      tenor: filterInput.tenor,
      outlet_id_list: filterInput.outlets,
      date_start: filterInput.transactionStartDate,
      date_end: filterInput.transactionEndDate,
      page: parseInt(filterInput.page),
      size: parseInt(filterInput.pageSize),
      transaction_type: filterInput.transactionType,
      sorting_field: filterInput.sortingField,
      sorting_order: filterInput.sortingOrder,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}transaction-history/gadai/widget`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      ),
      (response) => {
        setLoading(false);

        setFinancialData({
          totalExpenditure: `Rp ${
            CurrencyFormat(response?.data?.data?.expense) || 0
          }`,
          totalIncome: `Rp ${
            CurrencyFormat(response?.data?.data?.income) || 0
          }`,
          totalProfit: `Rp ${
            CurrencyFormat(response?.data?.data?.profit) || 0
          }`,
        });
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data total: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getTransactionDetail = (transactionID) => {
    const data = {
      transaction_id: transactionID,
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}transaction-history/gadai/detail`;

    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data
      ),
      (response) => {
        const detail = convertTransactionDetail(response.data.data);
        setSelectedTransaction(detail);
        setIsDetailDialogOpen(true);
      },
      (error) => {
        console.log(error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data detail transaksi: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleOpenPreview = (src) => () => {
    setImgLink(src);
    setIsPreviewOpen(true);
  };

  const handleTextInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "pageSize") {
      setPageSizeValue(value);
    } else {
      setSearchNameValue(value);
    }
  };

  const handleEnter =
    (type = "enter") =>
    (event) => {
      const { name, value } = event.target;
      if (event.keyCode === 13 || type === "blur") {
        if (name === "pageSize" && value === "") {
          setPageSizeValue(10);
        }
        setFilterInput((prev) => ({
          ...prev,
          [name]: name === "pageSize" && value === "" ? 10 : value,
          page: 1,
        }));
      }
    };

  const handleSelectChange = (field, data) => {
    if (field === "category") {
      setSelectedCategory({
        value: data.value,
        label: data.label,
      });
    } else if (field === "paymentType") {
      setSelectedPaymentType({
        value: data.value,
        label: data.label,
      });
    } else if (field === "tenorType") {
      setSelectedTenorType({
        value: data.value,
        label: data.label,
      });
    } else if (field === "tenor") {
      setSelectedTenor({
        value: data.value,
        label: data.label,
      });
    } else if (field === "paymentMethod") {
      setSelectedPaymentMethod({
        value: data.value,
        label: data.label,
      });
    }

    setFilterInput((prev) => ({
      ...prev,
      [field]: data.value,
      page: 1,
    }));
  };

  const handleDateChange = (event) => {
    const startDate = moment(event?.[0]?._d).startOf("day");
    const endDate = moment(event?.[1]?._d).startOf("day");
    console.log([startDate, endDate]);
    setDateValue(event ? [startDate, endDate] : null);
    setFilterInput((prev) => ({
      ...prev,
      transactionStartDate: event ? new Date(startDate) : null,
      transactionEndDate: event ? new Date(endDate) : null,
      page: 1,
    }));
  };

  const getMonthly = () => {
    let startOfMonth = moment().startOf("month");
    let endOfMonth = moment();

    setDateValue([startOfMonth, endOfMonth]);
    setFilterInput((prev) => ({
      ...prev,
      transactionStartDate: new Date(startOfMonth),
      transactionEndDate: new Date(endOfMonth),
    }));
  };

  const handleSingleOutletChange = (list) => {
    setOutletCheckedList(list);
    setIndeterminate(!!list.length && list.length < outletList.length);
    setOutletCheckAll(list.length === outletList.length);
  };

  const handleOutletCheckAllChange = (event) => {
    const outletListId = outletList.map((outlet) => {
      return outlet.value;
    });

    setOutletCheckedList(event.target.checked ? outletListId : []);
    setIndeterminate(false);
    setOutletCheckAll(event.target.checked);
  };

  const handleOutletButtonClick = () => {
    setIsOutletDialogOpen(true);
  };

  const handleOutletSave = () => {
    setFilterInput((prev) => ({
      ...prev,
      outlets: outletCheckedList,
      page: 1,
    }));
    setIsOutletDialogOpen(false);
  };

  const handleOutletCancel = () => {
    setSelectedTransaction({});
    setIsDetailDialogOpen(false);
    setIsOutletDialogOpen(false);
  };

  const handleDetailButtonClick = (transactionID) => {
    getTransactionDetail(transactionID);
  };

  const handlePrintReceipt = () => {
    window.open(
      `/history/pawn/print-nota/${selectedTransaction.transactionID}`,
      "_blank",
      "noopener"
    );
    setIsDetailDialogOpen(false);
  };

  const handleReset = () => {
    setSelectedCategory(initCategoryAndTenor);
    setSelectedTenor(initCategoryAndTenor);
    setSelectedTenorType(initPaymentAndTenorType);
    setSelectedPaymentType(initPaymentAndTenorType);
    setSearchNameValue("");
    setPageSizeValue(10);
    setDateValue([]);

    const outletListId = outletList.map((outlet) => {
      return outlet.value;
    });

    setOutletCheckedList(outletListId);
    setIndeterminate(false);
    setOutletCheckAll(true);

    setFilterInput(initFilterInput);
  };

  const handleTransactionTypeChange = (e) => {
    setIsChangingType(true);
    const currentValue = e.target.value;

    setTransactionTypeCount((prev) => {
      const temp = [...prev];
      temp.map((transType) => {
        transType.active = currentValue === transType.value ? true : false;
        return transType;
      });
      return temp;
    });

    setFilterInput((prev) => ({
      ...prev,
      transactionType: currentValue,
      page: 1,
    }));
  };

  const handleTableChange = (pagination, _, sorter) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      pageSize: parseInt(pagination.pageSize),
      sortingField: sorter?.column?.backend_key || null,
      sortingOrder:
        sorter?.order === "ascend"
          ? "ASC"
          : sorter?.order === "descend"
          ? "DESC"
          : null,
    }));
  };

  const handleExport = (type) => (e) => {
    if (type === "excel") {
      handleExportExcel();
    }
  };

  const handleExportExcel = () => {
    const data = {
      query: filterInput.searchName,
      product_category: filterInput.category,
      payment_type: filterInput.paymentType,
      tenor_type: filterInput.tenorType,
      tenor: filterInput.tenor,
      outlet_id_list: filterInput.outlets,
      date_start: filterInput.transactionStartDate,
      date_end: filterInput.transactionEndDate,
      page: parseInt(filterInput.page),
      size: parseInt(filterInput.pageSize),
      transaction_type: filterInput.transactionType,
      sorting_field: filterInput.sortingField,
      sorting_order: filterInput.sortingOrder,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}transaction-history/gadai/excel/full`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
          "content-type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
        "blob"
      ),
      (response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "riwayat_transaksi_gadai.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal export data menjadi excel: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  useEffect(() => {
    getPawnTransactionList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterInput]);

  useEffect(() => {
    getCategory();
    getOutlet();
    getTenorList();
    getMonthly();
  }, []);

  return (
    <div>
      <div className="px-3">
        <div className="py-4 d-flex flex-column" style={{ fontSize: "13px" }}>
          <Title text={"Riwayat Transaksi Gadai"} />
          <Breadcrumb current={"Transaksi Gadai"} />
          <div className="d-flex justify-content-end">
            <ActiveOutlets
              outletList={outletList}
              activeOutlets={outletCheckedList}
            />
          </div>
        </div>

        <div className="d-flex justify-content-between filter-bar">
          <TextInput
            id={"pageSize"}
            label={"Tampilkan"}
            width={"7%"}
            handleEnter={handleEnter}
            value={pageSizeValue}
            handleChange={handleTextInputChange}
          />
          <TextInput
            id={"searchName"}
            label={"No. SBG / No. Kwitansi / Nama Nasabah"}
            width={"30%"}
            placeholder={"Cari.."}
            handleEnter={handleEnter}
            value={searchNameValue}
            handleChange={handleTextInputChange}
          />
          <MultipleSelect
            id={"category"}
            label={"Kategori Produk"}
            isSearchable={true}
            onSelectChange={handleSelectChange}
            options={categoryList}
            value={selectedCategory}
          />
          <MultipleSelect
            id={"paymentType"}
            label={"Jenis Pembayaran"}
            onSelectChange={handleSelectChange}
            options={paymentTypeList}
            value={selectedPaymentType}
          />
          <MultipleSelect
            id={"tenorType"}
            label={"Jenis Tenor"}
            options={tenorTypeList}
            onSelectChange={handleSelectChange}
            value={selectedTenorType}
          />
          <div className="filter-bar">
            <Button
              variant="link"
              className="btn-action btn-reset"
              onClick={handleReset}
            >
              Reset semua filter
            </Button>
          </div>
        </div>

        <div className="d-flex filter-bar-2">
          <MultipleSelect
            id={"tenor"}
            label={"Tenor"}
            onSelectChange={handleSelectChange}
            options={tenorList}
            value={selectedTenor}
          />
          <ButtonInput
            id={"outlet"}
            label={"Cabang/Outlet"}
            buttonText={"Pilih Cabang"}
            onButtonClick={handleOutletButtonClick}
            variant={"outline-secondary"}
            width={"13%"}
          />
          <CustomDatePicker
            id={"pawnTransaction"}
            label={"Tanggal Transaksi"}
            isRangePicker
            width="20%"
            onInputChange={handleDateChange}
            value={dateValue}
          />
          <MultipleSelect
            id={"paymentMethod"}
            label={"Metode Pembayaran"}
            onSelectChange={handleSelectChange}
            options={paymentMethodList}
            value={selectedPaymentMethod}
          />
        </div>

        <div className="d-flex filter-bar-2 align-items-center mt-2 mb-4">
          <span style={{ fontSize: "15px" }}>Jenis Transaksi:</span>
          {transactionTypeCount.map((transactionCount) => {
            return (
              <FilterButton
                data={transactionCount}
                handleChange={handleTransactionTypeChange}
                type="transactionType"
              />
            );
          })}
        </div>

        <div style={{ marginBottom: "1.5rem" }}>
          <TotalSummary data={financialData} />
        </div>

        <CustomTable
          columns={renderColumns(handleDetailButtonClick)}
          data={pawnTransactionList}
          loading={loading}
          handleTableChange={handleTableChange}
          pagination={tablePagination}
          scrollX={1800}
        />

        <div className="filter-bar-2 d-flex" style={{ marginTop: "2rem" }}>
          <ExportButton
            handleExport={handleExport}
            pathname="/history/pawn/export"
            data={pawnTransactionList}
            from="pawn"
            columns={renderColumns()}
          />
        </div>
      </div>
      <ChooseOutletDialog
        title={"Pilih Cabang/Outlet"}
        visible={isOutletDialogOpen}
        handleSave={handleOutletSave}
        handleCancel={handleOutletCancel}
        data={outletList}
        onCheckAllChange={handleOutletCheckAllChange}
        onSingleChange={handleSingleOutletChange}
        indeterminate={indeterminate}
        outletCheckAll={outletCheckAll}
        outletCheckedList={outletCheckedList}
      />
      <DetailDialog
        setVisible={setIsDetailDialogOpen}
        visible={isDetailDialogOpen}
        handlePrint={handlePrintReceipt}
        handleCancel={handleOutletCancel}
        data={selectedTransaction}
        type="pawn"
      />
      <PreviewImage
        visible={isPreviewOpen}
        setVisible={setIsPreviewOpen}
        url={imgLink}
      />
    </div>
  );
};

export default PawnTransaction;
